const mapSpec = {
  version: 1,
  baseLayer: 'street',
  centreOfTheWorld: 'greenwich',
  layers: [],
};

export default mapSpec;



// WEBPACK FOOTER //
// ./src/constants/Visualisation/mapSpecTemplate.js